// extracted by mini-css-extract-plugin
export default {"title":"z0XtW","delimeter":"kqGLb"};